import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Change the curvature of the ceiling. Start with a strongly concave surface and finish with a strongly convex surface, with a flat surface in-between. Observe how the reflected rays converge or diverge, leading to an amplification or attenuation of the corresponding reflection level. The indicated parameter is the amplification at the receiving point due to the curvature of the ceiling. The reference value of 0 dB marks the case of the perfectly flat ceiling. Negative values denote attenuation instead of amplification.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      rowsSize: [9, 1],
      colsSize: [4, 1],
      components: [
        [
          [
            {
              variant: "layout",
              data: {
                type: "videoSlider",
                options: {
                  src: `${config.ASSETS_URL}/05/15/principle/video.mov`,
                },
                styles: {
                  padding: "3.3% 0 0 0",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/15/principle/amplification.svg`,
                  },
                },
                styles: {
                  padding: "2% 15% 20% 0",
                },
              },
            },
          ],
        ],
        [
          [
            {
              variant: "layout",
              data: {
                type: "table",
                options: {
                  cols: 3,
                  rows: 1,
                  colsSize: [2.3, 1, 1],
                  components: [
                    [
                      [
                        {
                          variant: "blockContainer",
                          data: {
                            block: {
                              type: "text",
                              options: {
                                data: "Concave surface",
                                scrollbars: false,
                              },
                            },
                            styles: {
                              alignItems: "flex-start",
                            },
                          },
                        },
                      ],
                      [
                        {
                          variant: "blockContainer",
                          data: {
                            block: {
                              type: "text",
                              options: {
                                data: "Flat surface",
                                scrollbars: false,
                              },
                            },
                            styles: {
                              alignItems: "flex-start",
                            },
                          },
                        },
                      ],
                      [
                        {
                          variant: "blockContainer",
                          data: {
                            block: {
                              type: "text",
                              options: {
                                data: "Convex surface",
                                scrollbars: false,
                              },
                            },
                            styles: {
                              alignItems: "flex-start",
                            },
                          },
                        },
                      ],
                    ],
                  ],
                },
              },
            },
          ],
        ],
      ],
    },
  },
};

export default principle;
